import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-required-marker',
	styleUrls: ['./required-marker.component.scss'],
	templateUrl: './required-marker.component.html',
	standalone: false,
})
export class RequiredMarkerComponent {}
